<template>
    <div>
        <nav-bar></nav-bar>
        <div class="person-box" v-if="!['/personCenter/detail','/personCenter/paperDetail','/personCenter/resourceDetail'].includes($route.path)">
        <div class="banner-box">
            <div class="info-box">
                <el-image 
                    class="user-cover"
                    fit="cover"
                    :src="userInfo.avatar ? $severUrl(userInfo.avatar) : $profile" 
                    :preview-src-list="[userInfo.avatar ? $severUrl(userInfo.avatar) : $profile]">
                </el-image>
                <!-- <img class="user-cover" :src="userInfo.avatar ? $severUrl(userInfo.avatar) : $profile" alt=""> -->
                <div class="user-info">
                    <div class="userName">
                        <div style="max-width: 15rem;" class="overflow">{{ userInfo.userName || userInfo.loginName }}</div>
                        <div>，你好</div>
                        <img :src="ev" class="ev-img" style="cursor: pointer;margin-left: 1.5rem;" alt="" @click="openUserInfo('base')">
                    </div>
                    <div class="user-school">{{ userInfo.schoolName }}</div>
                    <div v-if="userInfo.accountType">
                    <div class="real-name" v-if="[0,3].includes(userInfo.authStatus)"  @click="openUserInfo('real')">身份认证>></div>
                    <div v-if="filterStatus(userInfo.authStatus).value" class="real-status"  :style="`background-color:${filterStatus(userInfo.authStatus).value};`">{{ filterStatus(userInfo.authStatus).label }}</div>
                    <el-tag :style="`margin-left:${accountRole().value=='info'?0:1}rem;`" :type="accountRole().value">{{ accountRole().label }}</el-tag>
                </div>
                </div>
            </div>
            <div class="r-top-box">
                <div v-for="(item, index) in courseStatistics" class="course-item" :key="index">
                    <div>
                        <div>{{ item.number || 0 }}</div>
                        <div>{{ item.label }}</div>
                    </div>
                    <div :class="{ 'last-active': index == courseStatistics.length - 1 }"></div>
                </div>
            </div>
        </div>
        <div class="env-box">
            <div class="nav-box">
                <div v-for="(item, index) in personNavList" class="nav-item" :class="{ active: currentNav == item.value }"
                    @click.stop="changeNav(item)" :key="index">
                    <div :class="{ active: currentNav == item.value }">{{ item.label }}</div>
                    <div :class="{ 'border-active': currentNav == item.value }" class="border-show"></div>
                </div>
            </div>
            <div class="input-box" @click.stop v-if="isShow&&!isPhoneSearch">
                <div @click="changeTab">搜索</div>
                <el-input v-model="keywords" style="width: 20rem;" @keyup.enter.native="changeTab" clearable @clear="changeTab" placeholder="请输入名称">
                    <template slot="prefix">
                        <div class="search-ipt-box">
                            <img @click="changeTab" style="cursor: pointer;width: 16px;height: auto;"
                                src="../assets/image/magSys/search.png" alt="">
                        </div>
                    </template>
                </el-input>
            </div>
            <img v-if="isPhoneSearch" @click.stop="isPhoneSearch=false" class="search-image" src="../assets/image/magSys/search.png" alt="">
        </div>
        <div class="content-box">
            <div class="category-box" v-if="isShow&&!['myselfTask'].includes(currentNav)">
                <div v-for="(item, index) in Category" class="category-item" :key="index">
                    <div :class="{ active: currentTab == item.value }" @click="changeTab(item)">{{ item.label }}</div>
                    <div v-if="index < Category.length - 1" class="split-line"></div>
                </div>
            </div>
            <div class="tab-content">
                <myself-collection :classifyCode="currentTab" @changeModel="changeActive" :activeName="activeName" :name="keywords" ref="myselfCollection"
                    v-if="currentNav == 'myselfCollection'"></myself-collection>
                <my-study-course :classifyCode="currentTab" :name="keywords" ref="myStudyCourse"
                    v-if="currentNav == 'myStudyCourse'"></my-study-course>
                <train-record :classifyCode="currentTab" @changeOpt="changeOpt" :name="keywords" ref="trainRecord"
                    v-if="currentNav == 'trainRecord'"></train-record>
                <myself-task v-if="currentNav == 'myselfTask'" ref="myselfTask" :classifyCode="currentTab" :name="keywords"></myself-task>
                <examine :classifyCode="currentTab" ref="examine" v-if="currentNav == 'examine'"></examine>
            </div>
        </div>
    </div>
    <router-view v-else></router-view>
    <person-info ref="person_info" :changeType="changeType"></person-info>
    </div>
</template>

<script>
import { Category } from '@/utils/utils';
import MyselfCollection from '../components/personCenter/MyselfCollection.vue';
import MyStudyCourse from '../components/personCenter/MyStudyCourse.vue';
import TrainRecord from '../components/personCenter/TrainRecord.vue';
import PersonInfo from '../components/personCenter/PersonInfo.vue';
import { QueryUserInfo, GetUserDataStatistics } from '@/api/user';
import { Logout } from '@/api/common/common';
import { QueryResource } from '@/api/common/common';
import Utils from "@/assets/js/Utils";
import MyselfTask from '../components/personCenter/MyselfTask.vue';
export default {
    name: 'PersonCenter',
    components: { MyselfCollection, MyStudyCourse, TrainRecord,PersonInfo, MyselfTask },
    data() {
        return {
            Category: [{ label: '全部', value: '' }, ...Category],
            isShow:true,
            keywords: '',
            ev: require('../assets/image/person/edit.png'),
            /**修改信息类型 */
            changeType: '',
            /**课程统计 */
            courseStatistics: [],
            isMounted: true,
            /**当前tab */
            currentTab: '',
            activeName:'course',
            isPhoneSearch:false
        }
    },
    methods: {
        /**过滤认证状态 */
        filterStatus(status) {
            var obj = {
                0: {
                    label: "未认证",
                    value: 'rgba(119,127,139,0.6)'
                },
                1: {
                    label: '已认证',
                    value: '#67c23a'
                },
                2: {
                    label: '认证中',
                    value: '#e6a23c'
                },
                3: {
                    label: '认证失败',
                    value: '#f56c6c'
                }
            }
            return obj[status] || {};
        },
        closeSearch(){
            if(!this.showSlider)return;
            this.isPhoneSearch=true;
        },
        /**账号角色判断 */
        accountRole(){
            let roleCode=this.$store.state.user.userInfo.roleCode;
            let accountType=this.$store.state.user.userInfo.accountType;
            let obj={};
            if(accountType==1){
                if(roleCode=='global_001'){
                    obj.label='老师';
                    obj.value='';
                }else if(roleCode=='global_002'){
                    obj.label='学生';
                    obj.value='success';
                }else{
                    obj.label='游客';
                    obj.value='warning';
                }
            }else{
                obj.label='管理员';
                obj.value='info';
            }
            return obj;
        },
        changeActive(value){
            this.activeName=value;
        },
        changeOpt(e){
            this.isShow=e;
        },
        /**打开用户信息 */
        openUserInfo(type) {
            this.changeType = type;
            var dialog = this.$refs['person_info'];
            if (dialog) {
                dialog.dialogVisible = true;
                dialog.title=(type=='base'?'个人信息':'身份认证');
                dialog.form = JSON.parse(JSON.stringify(this.userInfo));
                dialog.getBusinessRole();
                if (this.userInfo.tenantId == 'zdzx') {
                    dialog.form.tenantId = '';
                }
                if (type == 'real') {
                    dialog.querySchool();
                }
            }
        },
        /**切换tab */
        changeTab(item) {
            if(item){
                this.currentTab = item.value;
            }
            this.$nextTick(() => {
                var tab = this.$refs[this.currentNav];
                if (tab) {
                    tab.search();
                }
            })

        },
        /**递归获取菜单 */
        handleMenu(data, arr = []) {
            data.forEach(item => {
                if (item.type == '1') {
                    arr.push(item);
                }
                if (item.children && item.children.length > 0) {
                    this.handleMenu(item.children, arr);
                }
            })
            return arr;
        },
        /**获取资源权限 */
        queryResource() {
            QueryResource({ appCode: process.env.VUE_APP_APP_CODE }).then(res => {
                if (res.code == 200) {
                    var menuList = [];
                    var el = res.data.horizontalMenuList.find(item => item.url == '/personCenter');
                    var horizontal = {};
                    var horizontalMenuList = [];
                    if (el) {
                        el.children.forEach(item => {
                            if (item.type == '1') {
                                menuList.push(item)
                            } else {
                                horizontal = item;
                            }
                        })
                    }
                    var data = menuList.map((item, index) => {
                        return {
                            label: item.name,
                            value: item.url.replace('/', ''),
                            path: item.url,
                            iconfont: require(`../assets/image/person/m${index > 5 ? 1 : index + 1}.png`)
                        }
                    })
                    if (horizontal.children) {
                        horizontalMenuList = horizontal.children;
                    }
                    var nav = data.find(item => item.value == this.currentNav);
                    if (data && data.length > 0 && !nav) {
                        this.$store.commit('changeCurrentNav', data[0].value);
                    }
                    this.$store.commit('changePersonNavList', data);
                    this.$store.dispatch('setPermissions', res.data.permissions);
                    this.courseStatistics = horizontalMenuList.map((item, index) => {
                        return {
                            label: item.name,
                            value: index,
                            number: 0
                        }
                    })
                    this.getUserDataStatistics();
                }
            })
        },
        /**获取用户数据统计 */
        getUserDataStatistics() {
            GetUserDataStatistics().then(res => {
                if (res.code == 200) {
                    var obj = {
                        '我创建的课程': 'myCreateCourseCount',
                        '我学习的课程': 'myStudyCourseCount',
                        '我的资源': 'myResCount',
                        '我的试卷': 'myTestPaperCount',
                        '虚拟仿真实训': 'softwareCount',
                        '在线总时长（min）': 'userOnlineCount'
                    }
                    this.courseStatistics.forEach(item => {
                        item.number = res.data[obj[item.label]];
                    })
                }
            })
        },
        /**获取用户基本信息 */
        queryUserInfo() {
            QueryUserInfo().then(res => {
                if (res.code == 200) {
                    this.$store.commit('changeUserInfo', res.data);
                }
            })
        },
        /**切换导航 */
        changeNav(item) {
            this.$store.commit('changeCurrentNav', item.value);
        },
        /**刷新身份认证 */
        refreshUser(e) {
            Logout().then(() => {
                this.$store.dispatch('setUserData', e);
                this.queryUserInfo();
                this.queryResource();
            })
        }
    },
    computed: {
        currentNav() {
            return this.$store.state.menu.currentNav;
        },
        userInfo() {
            return this.$store.state.user.userInfo;
        },
        personNavList() {
            return this.$store.state.menu.personNavList;
        },
        showSlider(){
            return this.$store.state.media.showSlider;
        }
    },
    mounted() {
        window.addEventListener('click',this.closeSearch);
        this.queryResource();
        Utils.$on('refresh_user_audit_token', this.refreshUser);
    },
    beforeDestroy(){
        window.removeEventListener('click',this.closeSearch);
    },
    activated() {
        if (!this.isMounted) {
            this.queryResource();
            var obj = {
                myselfCollection: 'queryTableList',
                myselfCourse: 'queryCourse',
                myStudyCourse: 'queryStudyCourse',
                examine: 'queryNoExamineUser',
                trainRecord: 'querySoftwareDrillList',
            }
            var dialog = this.$refs[this.currentNav];
            if (dialog) {
                var ev = dialog[obj[this.currentNav]];
                ev && ev();
            }
        }
    },
    watch:{
        showSlider:{
            handler(value){
                if(value){
                    this.isPhoneSearch=true;
                }else{
                    this.isPhoneSearch=false;
                }
            },
            immediate:true
        }
    },
    deactivated() {
        this.isMounted = false;
    },
    destroyed() {
        Utils.$off('refresh_user_audit_token', this.refreshUser);
    }
}
</script>

<style lang="less" scoped>
.person-box {
    background-color: rgb(247, 247, 249);
    min-height: calc(100vh - 8.5rem);
    .banner-box {
        min-height: 20rem;
        margin-top: 8.5rem;
        background-image: url('../assets/image/person/bg-person.png');
        background-size: 100% 100%;
        padding: 0 var(--padding);
        padding-top: 3rem;
        display: flex;
        justify-content: space-between;

        .info-box {
            display: flex;
            align-items: center;
            color: #ffffff;

            .userName {
                font-size: 1.8rem;
                font-weight: 700;
                margin-bottom: 0.8rem;
                display: flex;
                align-items: center;
            }
        }

        .user-cover {
            width: 7.2rem;
            height: 7.2rem;
            border-radius: 50%;
            object-fit: cover;
        }
    }

    .env-box {
        height: 6rem;
        display: flex;
        color: #334681;
        padding: 0 var(--padding);
        align-items: center;
        justify-content: space-between;
        border: 1px solid #ffffff;
        background-color: #ffffff;

        .nav-box {
            display: flex;
            font-size: 1.8rem;
            height: 100%;
            flex: 1;
            .nav-item {
                margin-left: 6.5rem;
                height: 100%;
                position: relative;
                display: flex;
                align-items: center;
                cursor: pointer;
            }

            &> :nth-child(1) {
                margin-left: 0;
            }
        }
        .search-image{
            margin-left: 1rem;
           cursor: pointer;
        }
    }

    .user-info {
        margin-left: 2.6rem;
    }
}

.r-top-box {
    display: flex;
    align-items: center;
}

.course-item {
    display: flex;
    align-items: center;
    color: #ffffff;

    &> :nth-child(1) {
        display: flex;
        flex-direction: column;
        padding-left: 3rem;

        &> :nth-child(1) {
            font-size: 1.8rem;
            font-weight: 700;
            margin-bottom: 1rem;
        }

        &> :nth-child(2) {
            font-size: 14px;
        }
    }

    &> :nth-child(2) {
        width: 1px;
        height: 1.7rem;
        background-color: #E8ECEF;
        margin-left: 3rem;
    }
}

.last-active {
    background-color: transparent !important;
}

.input-box {
    display: flex;
    align-items: center;
    color: #334681;

    &> :nth-child(1) {
        margin-right: 1rem;
    }

    /deep/.el-input__inner {
        height: 4rem;
        border-radius: 1rem;
        padding-left: 3.5rem;
    }

    .search-ipt-box {
        display: flex;
        align-items: center;
        width: 3.5rem;
        justify-content: center;
        height: 100%;
    }
}

.border-show {
    position: absolute;
    height: 4px;
    width: 2rem;
    border-radius: 2px 2px 0px 0px;
    background: transparent;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
}

.active {
    color: var(--blue);
}

.border-active {
    background: var(--blue);
}

.content-box {
    padding: 0 var(--padding);
    .category-box {
        display: flex;
        padding: 3rem 0 1.5rem 0;

        .category-item {
            margin-left: 2.4rem;
            color: #334681;
            display: flex;
            align-items: center;

            &> :nth-child(1) {
                cursor: pointer;
            }

            .split-line {
                width: 1px;
                height: 0.8rem;
                background: #b2c6df;
                margin-left: 2.4rem;
            }
        }

        &> :nth-child(1) {
            margin-left: 0;
        }
    }
}
.real-name{
    font-size: 14px;
    color: var(--blue);
    cursor: pointer;
    margin-top: 1rem;
}
.real-status{
    color: black;
    padding: 2px 8px;
    border-radius: 8px;
    display: inline-block;
    color: #ffffff;
    margin-top: 1rem;
}
@media screen and (max-width:750px){
    .banner-box{
        display: block !important;
    }
    .category-box{
        overflow: auto;
    }
    .input-box{
        margin-left: 3rem;
    }
    .r-top-box{
        width: 100%;
        overflow: auto;
        margin-top: 2rem;
        padding-bottom: 2rem;
    }
    .r-top-box> :first-child> :first-child{
        padding-left: 0 !important;
    }
    .nav-box{
        width: 50%;
        overflow: auto;
    }
    .category-item{
        justify-content: center;
        background-color: #ffffff;
        padding:1rem 2rem;
        border-radius: 1rem;
    }
    .split-line{
        display: none;
    }
    .nav-item{
        font-weight: 700;
    }
}
</style>